var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_791_14106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 4.375V8.74978L11.6665 10.208",
    stroke: "currentColor",
    strokeWidth: 1.45826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74932 16.0406C12.7762 16.0406 16.0406 12.7762 16.0406 8.74932C16.0406 4.72244 12.7762 1.45801 8.74932 1.45801C4.72244 1.45801 1.45801 4.72244 1.45801 8.74932C1.45801 12.7762 4.72244 16.0406 8.74932 16.0406Z",
    stroke: "currentColor",
    strokeWidth: 1.45826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_791_14106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4991,
    height: 17.4991,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.ec858ecd21fc581e5ad6622683f656bc.svg";
export { ForwardRef as ReactComponent };